module.exports = __webpack_public_path__ + "stylesheets/section-different-devices_d40651290307fc1ba8e7450853a97729.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-different-devices.less
// module id = LxjB
// module chunks = 154